// 1. keeps track of what user has answered in fake / real news puzzle && fires a function when everything is ready
// 2. keeps track if user has completed clock puzzle
// nb. choice is either true or false

import {wallSwitchState} from "../puzzles/wallSwitch"
import { registerEvent } from "./analyticsMethods";

export const userChoiceTracker = (() => { 
    const answers = {
        corridorDoorOpened: false,  
        rightTwitterPassword: false,
        posterPuzzle: false,
        flatPuzzle2: false, 
        warehousePuzzle1: false, 
        bunkerPuzzle2: false, 
        clockPuzzle: false,
        electricPanel: false, 
        endSwitch: true
    }


    let wrongAnswers = 0; 

    const registerWrongAnswer = () => {
        wrongAnswers = wrongAnswers++;
    } 

    let previousState= {
        flatPuzzle2: null,
        warehousePuzzle1: null,
        bunkerPuzzle2: null
    }

    let openedDoors = [];

    let amountFNPuzzlesSolved = 0;

    return {
        processAnswer: (puzzle, correctAnswer) => {
            
            if(correctAnswer) {
             answers[puzzle] = true
             if (puzzle === "flatPuzzle2") {
                registerEvent("Email_ratkaistu")
             }

             if (puzzle === "warehousePuzzle1") {
                registerEvent("Framegram_ratkaistu")
             }

             if (puzzle === "bunkerPuzzle2") {
                registerEvent("Facebook_ratkaistu")
             }
            } else {
             answers[puzzle] = false
             wallSwitchState.active = false
                registerWrongAnswer();
            }



            amountFNPuzzlesSolved = [answers.flatPuzzle2, answers.bunkerPuzzle2, answers.warehousePuzzle1].filter(Boolean).length;

            if(answers.flatPuzzle2 && answers.bunkerPuzzle2 && answers.warehousePuzzle1) {
                wallSwitchState.active = true
            }
        }, 
        retrieve: () => answers,
        addOpenedDoor: (door) => {
            openedDoors.push(door);
        },
        fakeNewsSolved: () => answers.flatPuzzle2 ? 3 : amountFNPuzzlesSolved,  // if flatPuzzle 2 solved, everything should be
        openedDoors: openedDoors,
        retrievePreviousState: (puzzleCode) => previousState[puzzleCode],
        saveState: (puzzleCode, state) => previousState = {...previousState, [puzzleCode]: state},
        retrieveWrongAnswer: () => wrongAnswers,
        calculateCorrectAnswers: () => {
            let value = 0;
        
           const facebookPuzzles = ["flatPuzzle2", "warehousePuzzle1", "bunkerPuzzle2"]
           for (const prop in answers) {
               console.log(answers[prop]) 
               if (answers[prop] && facebookPuzzles.indexOf(prop) > -1) value++;
            }

            return value

        },
        solved: () => {
            userChoiceTracker.processAnswer("flatPuzzle2",true);
            userChoiceTracker.processAnswer("bunkerPuzzle2",true);
            userChoiceTracker.processAnswer("warehousePuzzle1",true);
            wallSwitchState.active = true
        },
        clockPuzzleResolved: () => answers.clockPuzzle = true,
        electricPanelPuzzleResolved: bool => {
            if (bool) {
            answers.electricPanel = bool}
        else return answers.electricPanel
        },
    }
})()